import {AuthorizationUtils} from "../../utils/AuthorizationUtils";
import {
  ORDER_CHANGE_BILLING_ADDRESS,
  ORDER_CHANGE_CUSTOMER,
  ORDER_CHANGE_PERSONA,
  ORDER_CHANGE_SHIPPING_ADDRESS
} from "../OrderActions";
import {DocumentUtils} from "../../utils/DocumentUtils";
import {FormUtils} from "../../utils/FormUtils";

export const SUBFORM_CLOSE = 'SUBFORM_CLOSE';
export const SUBFORM_OPEN = 'SUBFORM_OPEN';
export const SUBFORM_REQUEST_ERROR = 'SUBFORM_REQUEST_ERROR';
export const SUBFORM_WINDOW_RESIZE = 'SUBFORM_WINDOW_RESIZE';
export const SUBFORM_CUSTOMER_RESULT = 'SUBFORM_CUSTOMER_RESULT';
export const SUBFORM_PERSONA_RESULT = 'SUBFORM_PERSONA_RESULT';
export const SUBFORM_ADDRESS_RESULT = 'SUBFORM_ADDRESS_RESULT';

export const windowResize = (sizes) => (dispatch) => {
  dispatch({
    type: SUBFORM_WINDOW_RESIZE,
    action: sizes
  });
};

export const closeSubform = () => (dispatch) => {
  dispatch({
    type: SUBFORM_CLOSE
  });
};

export const useCustomer = (customerId) => (dispatch) => {
  dispatch({type: ORDER_CHANGE_CUSTOMER, action: customerId});
};

export const usePersona = (personaId) => (dispatch) => {
  dispatch({type: ORDER_CHANGE_PERSONA, action: personaId});
};

export const useAddress = (addressType, addressId) => (dispatch) => {
  dispatch({type: addressType, action: addressId});
};

export const createCustomer = (formValues, config) => (dispatch) => {
  fetch(`${config.api.baseUrl}/customers`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
    },
    body: JSON.stringify(getCreateCustomerBody(formValues))
  })
    .then(response => response.json())
    .then(
      (result) => {
        if (result.status && result.status >= 400) {
          dispatch({type: SUBFORM_CUSTOMER_RESULT, response: {error: result}});
        } else {
          dispatch({type: ORDER_CHANGE_CUSTOMER, action: result.customerId});
          dispatch({type: SUBFORM_CUSTOMER_RESULT, response: {result}});
          dispatch({type: ORDER_CHANGE_PERSONA, action: null});
          dispatch({type: ORDER_CHANGE_BILLING_ADDRESS, action: null});
          dispatch({type: ORDER_CHANGE_SHIPPING_ADDRESS, action: null});
        }
      },
      (error) => {
        dispatch({type: SUBFORM_CUSTOMER_RESULT, response: {error}});
      }
    )
    .catch(
      (error) => {
        dispatch({type: SUBFORM_CUSTOMER_RESULT, response: {error}});
      }
    );
};

export const getCreateCustomerBody = (formValues) => {
  return FormUtils.getNotEmptyValues(formValues);
};

export const createPersona = (formValues, config, customerId) => (dispatch) => {
  fetch(`${config.api.baseUrl}/customers/${customerId}/personas`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
    },
    body: JSON.stringify(getCreatePersonaBody(formValues))
  })
    .then(response => response.json())
    .then(
      (result) => {
        if (result.status && result.status >= 400) {
          dispatch({type: SUBFORM_PERSONA_RESULT, response: {error: result}});
        } else {
          dispatch({type: ORDER_CHANGE_PERSONA, action: result.personaId});
          dispatch({type: SUBFORM_PERSONA_RESULT, response: {result}});
        }
        DocumentUtils.scrollTop('persona_form_container');
      },
      (error) => {
        dispatch({type: SUBFORM_PERSONA_RESULT, response: {error}});
        DocumentUtils.scrollTop('persona_form_container');
      }
    )
    .catch(
      (error) => {
        dispatch({type: SUBFORM_PERSONA_RESULT, response: {error}});
        DocumentUtils.scrollTop('persona_form_container');
      }
    );
};

export const getCreatePersonaBody = (formValues) => {
  return FormUtils.getNotEmptyValues(formValues);
};

export const createAddress = (formValues, config, addressType, customerId) => (dispatch) => {
  fetch(`${config.api.baseUrl}/customers/${customerId}/addresses`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': AuthorizationUtils.base64(config.environment.merchantId, config.environment.apiKey)
    },
    body: JSON.stringify(getCreateAddressBody(formValues))
  })
    .then(response => response.json())
    .then(
      (result) => {
        if (result.status && result.status >= 400) {
          dispatch({type: SUBFORM_ADDRESS_RESULT, response: {error: result}});
        } else {
          dispatch({type: addressType, action: result.addressId});
          dispatch({type: SUBFORM_ADDRESS_RESULT, response: {result}});
        }
        DocumentUtils.scrollTop('address_form_container');
      },
      (error) => {
        dispatch({type: SUBFORM_ADDRESS_RESULT, response: {error}});
        DocumentUtils.scrollTop('address_form_container');
      }
    )
    .catch(
      (error) => {
        dispatch({type: SUBFORM_ADDRESS_RESULT, response: {error}});
        DocumentUtils.scrollTop('address_form_container');
      }
    );
};

export const getCreateAddressBody = (formValues) => {
  return FormUtils.getNotEmptyValues(formValues);
};







// WEBPACK FOOTER //
// ./src/order/subforms/SubformsActions.js